import { Coordinate, MediaDownloadDto } from 'collaboration-service';
import { Image, getLinkByName, styled } from 'imaginarity-react-ui';
import _ from 'lodash';
import * as React from 'react';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';
import { PostEditElementProps } from '../TypeImplementations/PostEdit';


const Grid = styled.div<{ columns: number; rows: number }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(${p => p.columns}, 1fr);
    grid-template-rows: repeat(${p => p.rows}, 1fr);
    pointer-events: auto;
`;

const GridCell = styled.div<{ isLastCol: boolean; isLastRow: boolean, select?: boolean }>`
    border-top: 1px solid red;
    border-left: 1px solid red;
    ${p => !p.isLastCol ? 'border-right: none;' : 'border-right: 1px solid red;'}
    ${p => !p.isLastRow ? 'border-bottom: none;' : 'border-bottom: 1px solid red;'}
    box-sizing: border-box;
    transition: background 0.2s;
    pointer-events: auto;
    background-color: ${p => p.select ? 'rgba(250, 5, 5, 0.5)' : 'rgba(255,255,255,0.1)'};
    &:hover {
        background: rgba(255,255,255,0.5);
    }
`;
interface EditImageGridProps<T> extends PostEditElementProps<T, Coordinate[]> {
    media: MediaDownloadDto;
    x: number;
    y: number;
}

const EditImageGrid = <T extends BaseEditItem = BaseEditItem>(p: EditImageGridProps<T>) => {
    const { getter, media, x, y } = p;
    const { value, setValue } = useGPEState(getter);
    const [cells, setCells] = React.useState<any[]>([]);
    const [aspectRatio, setAspectRatio] = React.useState<number>(1);

    const onClickCell = React.useMemo(() => (row: number, col: number) => () => {
        const copy = _.cloneDeep(value);
        const idx = _.findIndex(copy, cop => cop.x === row && cop.y === col);
        if (idx > 0)
            copy.splice(idx, 1);
        else
            copy.push({ x: row, y: col });
        setValue(copy);
    }, [value, setValue]);

    React.useEffect(() => {
        const arr: any[] = [];
        for (let row = 0; row < x; row++) {
            for (let col = 0; col < y; col++) {
                const isLastCol = col === x - 1;
                const isLastRow = row === y - 1;
                const select: boolean = _.find(value, v => v.x === row && v.y === col) !== undefined;
                arr.push(
                    <GridCell
                        key={`${row}-${col}`}
                        isLastCol={isLastCol}
                        isLastRow={isLastRow}
                        onClick={onClickCell(row, col)}
                        select={select}
                    />
                );
            }
        }
        setCells(arr);
    }, [x, y, onClickCell, value]);

    React.useEffect(() => {
        const uri = getLinkByName(media, 'self')?.uri ?? '';
        if (uri) {
            const img = new window.Image();
            img.onload = () => {
                if (img.naturalWidth && img.naturalHeight)
                    setAspectRatio(img.naturalWidth / img.naturalHeight);
            };
            img.src = uri;
        }
    }, [media]);


    return (
        <div style={{ position: 'relative' }}>
            <div id='boobla'>
                <Image src={getLinkByName(media, 'self')?.uri ?? ''} width='50%' />
            </div>
            <div style={{
                position: 'absolute', top: 0, left: 0, aspectRatio: aspectRatio?.toString(), width: '50%', display: "grid",
                gridTemplateColumns: `repeat(${x}, 1fr)`,
                gridTemplateRows: `repeat(${y}, 1fr)`,
            }}>
                <Grid columns={x} rows={y}>
                    {cells}
                </Grid>
            </div>
        </div>
    );
}
export default EditImageGrid;